import DashboardContainer from '../../components/dashboard/Dashboard';

const DashboardPage = () => {
  return <DashboardContainer />;
};

export default DashboardPage;
